import { webSocket, createConfig } from 'wagmi'
import {
  // mainnet,
  sepolia
} from 'wagmi/chains'
import { metaMask, safe, walletConnect } from 'wagmi/connectors'

const projectId = 'c08db2eab11f33370005c7ed15491862'
const infuraId = 'fb54a5b7badf4291859529b40ed652ab'

export const walletConnectConfig = createConfig({
  chains: [
    // mainnet,
    sepolia
  ],
  connectors: [
    metaMask(),
    walletConnect({ projectId }),
    safe(),
  ],
  transports: {
    // [mainnet.id]: webSocket(`wss://mainnet.infura.io/v3/${infuraId}`),
    [sepolia.id]: webSocket(`wss://sepolia.infura.io/ws/v3/${infuraId}`),
  },
})
